var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cities-facet"},[_c('select-facet',{attrs:{"name":"Communes","item-name":"name","item-value":"insee","options":_vm.metrics.cities,"values":_vm.formattedValues},on:{"change":_vm.updateSelection}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }